import React from 'react';
import Header from '../../components/Headers/Header';
import MyCoursesCard from '../MyCourses/components/MyCoursesCard/MyCoursesCard.jsx';
import ChatApp from '../../components/ChatApp/ChatApp.jsx'

const content = [
    { theme: 'Название темы', img: '/images/subject/chemistry.png', path: 'test.pdf' },
    { theme: 'Название темы', img: '/images/subject/chemistry.png', path: 'test.pdf' },
    { theme: 'Название темы', img: '/images/subject/chemistry.png', path: 'test.pdf' },
    { theme: 'Название темы', img: '/images/subject/chemistry.png', path: 'test.pdf' },
    { theme: 'Название темы', img: '/images/subject/chemistry.png', path: 'test.pdf' },
    { theme: 'Название темы', img: '/images/subject/chemistry.png', path: 'test.pdf' },
];

export default function VideoCard() {
    return (
        <div className='VideoCard p h-100'>
            <Header />
            <div className="VideoCard__container">
                {content.map((item, index) => (
                    <MyCoursesCard key={index} date={item.theme} img={item.img} />
                ))}
            </div>
            {/* <ChatApp /> */}
        </div>
    );
}
